import { useEffect, useRef, useState } from "react";

const AssignedLockbox = (props) => {
  const popupref = useRef(null);
  const searchref = useRef(null);
  const [query, setQuery] = useState("");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        props.activateoutsidecontainerclick();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Reset the search and focus the box each time the dropdown opens.
  useEffect(() => {
    if (props.visible) {
      setQuery("");
      // Focus after the popup paints so typing works immediately.
      const id = setTimeout(() => searchref.current?.focus(), 0);
      return () => clearTimeout(id);
    }
  }, [props.visible]);

  const labelFor = (item) =>
    typeof item === "object" ? item.displayLabel || "" : String(item);

  const filtered = (props.status || []).filter((item) =>
    labelFor(item).toLowerCase().includes(query.trim().toLowerCase()),
  );

  return (
    props.visible && (
      <div
        ref={popupref}
        className="w-full bg-white border border-gray-300 rounded-md gk-scr p-[10px] absolute z-50 top-[50px] left-[0px] self-start"
        style={props.style}
      >
        <input
          ref={searchref}
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search Lockbox..."
          className="w-full border border-gray-300 rounded-md px-2 py-1 text-sm mb-2 outline-none focus:border-themeColor"
        />

        <div className="w-full overflow-x-auto max-h-[120px]">
          {filtered.length === 0 ? (
            <p className="text-sm text-gray-400 py-[5px]">No matches</p>
          ) : (
            filtered.map((item, index) => {
              const isDisabled = item.disabled;

              return (
                <div
                  key={index}
                  onClick={() => {
                    if (isDisabled) return; // 🚫 block click
                    props.onClickcorrect(item);
                  }}
                  className={`flex flex-row items-center w-full py-[5px] text-sm rounded-xl transition
        ${
          isDisabled
            ? "text-gray-400 cursor-not-allowed bg-gray-100"
            : "cursor-pointer hover:bg-themeColor hover:text-white hover:px-[10px]"
        }`}
                >
                  <p className="font-medium PoppinsRegular text-sm">
                    {item.displayLabel || item}
                  </p>
                </div>
              );
            })
          )}
        </div>
      </div>
    )
  );
};

export default AssignedLockbox;
